import React, { useEffect, useState } from 'react';
import CheckIcon from '../icons/CheckIcon';
import NotAvailable from '../Common/NotAvailable';
import { endorsementsApi } from '../../services/endorsements';

interface ProviderEndorsedSkillsProps {
  providerId: number;
}

// EndorseModal saves skills as "A, B"; older rows may hold a JSON array
export const parseSkills = (skills?: string | null): string[] => {
  if (!skills) return [];
  if (skills.trim().startsWith('[')) {
    try {
      const parsed = JSON.parse(skills);
      if (Array.isArray(parsed)) return parsed.map((s) => String(s).trim()).filter(Boolean);
    } catch {
      // Not JSON after all; fall through to comma splitting
    }
  }
  return skills
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
};

// Skills from the provider's accepted endorsements, most endorsed first
const ProviderEndorsedSkills: React.FC<ProviderEndorsedSkillsProps> = ({ providerId }) => {
  // null while loading
  const [skills, setSkills] = useState<Array<[string, number]> | null>(null);

  useEffect(() => {
    let cancelled = false;
    endorsementsApi
      .getProviderEndorsements(providerId)
      .then((endorsements) => {
        const counts = new Map<string, number>();
        endorsements.forEach((e) =>
          parseSkills(e.skills_endorsed).forEach((skill) =>
            counts.set(skill, (counts.get(skill) || 0) + 1)
          )
        );
        if (!cancelled) setSkills(Array.from(counts).sort((a, b) => b[1] - a[1]));
      })
      .catch((err) => {
        console.error('Error fetching endorsed skills:', err);
        if (!cancelled) setSkills([]);
      });
    return () => {
      cancelled = true;
    };
  }, [providerId]);

  return (
    <section className="mb-8">
      <h3 className="font-['Ovo'] text-xl text-[#1f1f1f] uppercase mb-4">ENDORSED SKILLS</h3>
      {skills === null ? null : skills.length === 0 ? (
        <NotAvailable className="text-base" />
      ) : (
        <div className="space-y-3">
          {skills.map(([skill, count]) => (
            <div key={skill} className="flex items-center gap-2">
              <CheckIcon />
              <span className="font-['Open_Sans'] text-base text-[#1f1f1f]">{skill}</span>
              <span className="font-['Open_Sans'] text-sm text-[#767472]">({count})</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default ProviderEndorsedSkills;
